import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-07b6467d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "postHome" }
const _hoisted_2 = { class: "post" }
const _hoisted_3 = { class: "postCart" }
const _hoisted_4 = { style: {"padding":"0 0 10px 10px"} }
const _hoisted_5 = {
  class: "context",
  style: {"margin-top":"20px"}
}
const _hoisted_6 = { class: "postList" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["src"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = ["onClick"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_18 = { key: 1 }

import API from "@/api";
import { ref, watchEffect } from "vue";
import message from "@arco-design/web-vue/es/message";
import router from "@/router";
import {
  addPostUsingPost,
  listPostVoByPageUsingPost,
} from "@/api/postController";
import dayjs from "dayjs";
import {
  doPostFavourUsingPost,
  doPostThumbUsingPost,
} from "@/request/api/postController";
import UserSider from "@/components/sider/UserSider.vue";
import MdViewer from "@/components/md/MdViewer.vue";
import TopicSelect from "@/components/selecter/TopicSelecter.vue";
import EmojiPicker from "vue3-emoji-picker";
import "vue3-emoji-picker/css";

//查询参数

export default /*#__PURE__*/_defineComponent({
  __name: 'PostHomePage',
  setup(__props) {

const searchParams = ref<API.PostQueryRequest>({
  current: 1,
  pageSize: 10,
  sortField: "createTime",
  sortOrder: "descend",
});

//总值
const total = ref<number>(0);
//当前页
const current = ref<number>(0);
//是否显示加载
const loading = ref(true);
// 帖子列表
const dataList = ref<API.PostVO[]>([]);
//搜索关键词
const searchText = ref<string>("");
// 帖子内容
const post = ref<API.PostAddRequest>({
  content: "",
  tags: [],
});
/**
 * 搜索
 */
const search = () => {
  searchParams.value = {
    ...searchParams.value,
    current: 1,
    searchText: searchText.value,
  };
};

/**
 * 加载数据
 */
const loadData = async () => {
  loading.value = true;
  const response = await listPostVoByPageUsingPost(searchParams.value);
  if (response.data.code === 0 && response.data.data) {
    dataList.value = response.data.data?.records || [];
    total.value = response.data.data?.total || 0;
  } else {
    message.error("加载数据失败，" + response.data.message);
  }
  loading.value = false;
};

/**
 * 当分页变化时，改变搜索条件，触发数据加载
 */
const onPageChange = (page: number) => {
  searchParams.value = {
    ...searchParams.value,
    current: page,
  };
};

/**
 * 发布
 */
const publish = async () => {
  if (post.value.content == "") {
    message.error("请输入帖子内容");
    return;
  }
  const response = await addPostUsingPost(post.value);
  if (response.data.code === 0 && response.data.data) {
    message.success("发布成功");
    post.value.content = "";
    post.value.tags = [];
    loadData();
  } else {
    message.error("发布失败，" + response.data.message);
  }
};
/**
 * 点击菜单项
 * @param id
 */
const onClickMenuItem = async (url: string) => {
  router.push(url);
};

const onClickEmoji = (emoji: any) => {
  post.value.content += emoji.i;
};
/**
 * 点赞
 */
const onLikeChange = (item: any) => {
  if (item.isThumb == true) {
    item.thumbNum--;
  } else {
    item.thumbNum++;
  }
  item.isThumb = !item.isThumb;
  doPostThumbUsingPost({ bizId: item.id, bizType: "Post" });
};

/**
 * 收藏
 */
const onStarChange = (item: any) => {
  if (item.isFavour == true) {
    item.favourNum--;
  } else {
    item.favourNum++;
  }
  item.isFavour = !item.isFavour;
  doPostFavourUsingPost({ bizId: item.id, bizType: "Post" });
};
/**
 * 监听 searchParams 变量，改变时触发数据的重新加载
 */
watchEffect(() => {
  if (searchParams.value) {
    loadData();
  }
});

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_icon_face_smile_fill = _resolveComponent("icon-face-smile-fill")!
  const _component_a_popover = _resolveComponent("a-popover")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_input_search = _resolveComponent("a-input-search")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_IconHeartFill = _resolveComponent("IconHeartFill")!
  const _component_IconHeart = _resolveComponent("IconHeart")!
  const _component_IconStarFill = _resolveComponent("IconStarFill")!
  const _component_IconStar = _resolveComponent("IconStar")!
  const _component_icon_message = _resolveComponent("icon-message")!
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_typography_text = _resolveComponent("a-typography-text")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_image_preview_group = _resolveComponent("a-image-preview-group")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_list_item_meta = _resolveComponent("a-list-item-meta")!
  const _component_a_list_item = _resolveComponent("a-list-item")!
  const _component_a_list = _resolveComponent("a-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_row, { justify: "center" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, { span: "16" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_a_space, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, { type: "primary" }, {
                        default: _withCtx(() => [
                          _createTextVNode("随便聊")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_tooltip, { content: "可以上传图片且可编辑样式" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_button, {
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (onClickMenuItem('/post/edit/0')))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" 写文章 ")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(_component_a_textarea, {
                  modelValue: post.value.content,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((post.value.content) = $event)),
                  "auto-size": {
                minRows: 2,
                maxRows: 5,
              },
                  "show-word-limit": "",
                  "max-length": 5000,
                  placeholder: "快来和大家讨论吧~",
                  class: "postText"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_a_row, { style: {"width":"auto","font-size":"15px","margin-top":"10px"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, {
                      flex: "auto",
                      style: {"margin-left":"10px"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_space, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_popover, {
                              position: "bl",
                              trigger: "click"
                            }, {
                              content: _withCtx(() => [
                                _createVNode(_unref(EmojiPicker), {
                                  native: true,
                                  onSelect: onClickEmoji
                                })
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_a_button, { type: "text" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_icon_face_smile_fill),
                                    _createTextVNode(" 表情 ")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(TopicSelect, {
                              modelValue: post.value.tags,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((post.value.tags) = $event)),
                              placeholder: "选择你的话题",
                              limit: "5"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { flex: "auto" }),
                    _createVNode(_component_a_col, { flex: "70px" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, {
                          type: "primary",
                          shape: "round",
                          size: "large",
                          onClick: publish
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 发布 ")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_a_space, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input_search, {
                      placeholder: "搜索你感兴趣的帖子吧",
                      modelValue: searchText.value,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((searchText).value = $event)),
                      onSearch: search,
                      onKeydown: _withKeys(search, ["enter"])
                    }, null, 8, ["modelValue"]),
                    _createVNode(TopicSelect, {
                      modelValue: searchParams.value.tags,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((searchParams.value.tags) = $event)),
                      placeholder: "选择你感兴趣的话题",
                      limit: "5"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_tabs, {
                  size: "large",
                  centered: "",
                  onTabClick: _cache[5] || (_cache[5] = 
                (key) => {
                  searchParams.value.sortField = key;
                }
              )
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_tab_pane, { key: "createTime" }, {
                      title: _withCtx(() => [
                        _createTextVNode(" 最新")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_tab_pane, { key: "thumbNum" }, {
                      title: _withCtx(() => [
                        _createTextVNode(" 最热")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_a_list, {
                    bordered: false,
                    data: dataList.value,
                    "pagination-props": {
                  pageSize: searchParams.value.pageSize,
                  current: searchParams.value.current,
                  total: total.value,
                },
                    stripe: true,
                    onPageChange: onPageChange,
                    loading: loading.value
                  }, {
                    item: _withCtx(({ item }) => [
                      _createVNode(_component_a_list_item, {
                        class: "list-item",
                        "action-layout": "vertical"
                      }, {
                        actions: _withCtx(() => [
                          _createElementVNode("span", {
                            class: "action",
                            onClick: ($event: any) => (onLikeChange(item))
                          }, [
                            (item.isThumb)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                                  _createVNode(_component_IconHeartFill, { style: { color: '#f53f3f' } })
                                ]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_9, [
                                  _createVNode(_component_IconHeart)
                                ])),
                            _createTextVNode(" " + _toDisplayString(item.thumbNum), 1)
                          ], 8, _hoisted_7),
                          _createElementVNode("span", {
                            class: "action",
                            onClick: ($event: any) => (onStarChange(item))
                          }, [
                            (item.isFavour)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                                  _createVNode(_component_IconStarFill, { style: {"color":"#fff35d"} })
                                ]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_12, [
                                  _createVNode(_component_IconStar)
                                ])),
                            _createTextVNode(" " + _toDisplayString(item.favourNum), 1)
                          ], 8, _hoisted_10),
                          _createElementVNode("span", {
                            class: "action",
                            onClick: ($event: any) => (onClickMenuItem(`/post/detail/${item.id}`))
                          }, [
                            _createVNode(_component_icon_message),
                            _createTextVNode("回复 ")
                          ], 8, _hoisted_13)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_a_list_item_meta, { style: {"padding":"10px 0"} }, {
                            title: _withCtx(() => [
                              _createVNode(_component_a_space, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_avatar, null, {
                                    default: _withCtx(() => [
                                      _createElementVNode("img", {
                                        alt: "avatar",
                                        src: item.user.userAvatar
                                      }, null, 8, _hoisted_14)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createElementVNode("div", null, [
                                    _createVNode(_component_a_typography_text, { style: {"font-size":"16px","font-weight":"bold"} }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.user.userName), 1)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _hoisted_15,
                                    _createVNode(_component_a_typography_text, { style: {"color":"#9f9f9f"} }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(dayjs)(item.createTime).format(
                                  "YYYY-MM-DD HH:mm:ss"
                                )), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            description: _withCtx(() => [
                              _createElementVNode("div", {
                                onClick: ($event: any) => (onClickMenuItem(`/post/detail/${item.id}`)),
                                class: "postContent"
                              }, [
                                _withDirectives(_createElementVNode("div", null, [
                                  _createVNode(_component_a_typography_text, { style: {"font-size":"20px","margin-left":"18px"} }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.title), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ], 512), [
                                  [_vShow, item.title]
                                ]),
                                _createVNode(MdViewer, {
                                  value: item.content
                                }, null, 8, ["value"]),
                                _hoisted_17
                              ], 8, _hoisted_16),
                              (item.imgList.length > 0)
                                ? (_openBlock(), _createBlock(_component_a_image_preview_group, { key: 0 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_space, {
                                        size: "large",
                                        style: {"margin":"10px 20px 0"}
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.imgList, (img) => {
                                            return (_openBlock(), _createBlock(_component_a_image, {
                                              key: img,
                                              src: img,
                                              width: "200"
                                            }, null, 8, ["src"]))
                                          }), 128))
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true),
                              (item.tagList.length > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                    _createVNode(_component_a_space, { style: {"margin":"10px 20px 0"} }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.tagList, (tag) => {
                                          return (_openBlock(), _createBlock(_component_a_tag, { key: tag }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(tag), 1)
                                            ]),
                                            _: 2
                                          }, 1024))
                                        }), 128))
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 1
                  }, 8, ["data", "pagination-props", "loading"])
                ])
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, { span: "6" }, {
          default: _withCtx(() => [
            _createVNode(UserSider, { "biz-type": "post" })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})